import React, {Component} from 'react';
//import { HashLink as Link } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import '../styles/ScrollBannerText.scss';
import TextLoop from "react-text-loop";
import { Event } from '../utils/tracking.js';
import Cookies from 'js-cookie';

export default class ScrollBannerText extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            data: {
                isScreenIsSmall: false
            }
        }
    }

    render() {
        // Get the current date
        const currentDate = new Date();

        // Check if the current date is between December 1 and January 2
        const isBetweenDecemberAndJanuary = currentDate.getMonth() === 11 || (currentDate.getMonth() === 0 && currentDate.getDate() < 2);
        return (
            <div className="scroll-banner-text-container">                
                <div className="large-screen">
                    <TextLoop
                        interval={6000}
                        springConfig={{ stiffness: 70, damping: 31 }}
                        adjustingSpeed={500}                                
                    >                                                            
                        {window.location.hostname === "eel-client-internal-dev.herokuapp.com" &&      
                        <div className="text-banner dev">
                            This is a development site for internal-use.     
                        </div>   
                        }                                                      
                        <div className="text-banner mto-services">    
                            <Link 
                                to='/lp/mto'
                                onClick={()=> Event("Scroll banner text", `BusinessUpdate clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text Business Update")}
                            >                     
                                <div className='sub-container'>   
                                    <img 
                                        src="https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/scrolling-text-banner/ICON_-EEL-MTO-Services-_for-dark-BGs.webp"
                                        alt='mto services'
                                    />                             
                                    <span className="general-text">We are a licensed UL-certified manufacturer. Let us be an extension of your team. </span>  
                                    <span className='uppercase white-text'>LEARN MORE </span>                              
                                    <span className='covid-here-text-colour uppercase'>HERE</span>                                                   
                                </div>
                            </Link>     
                        </div>
                        <div className="square">                                    
                            <a 
                                aria-label="Downlight accessories combo offer link" 
                                href='/promo/downlight-accessories-combo-offer'
                                target='_blank' 
                                rel="noopener noreferrer"
                                onClick={()=> Event("Scroll banner text", `Downlightaccessoriescombo clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text downlight accessories combo offer link")}
                            >
                                <img
                                    srcSet="
                                    https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_1025px_x_35px.webp 1024w,
                                    https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_1440px_x_35px_-01.webp 1440w,
                                    https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_2000px_x_35px.webp 2000w,
                                    https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_2560_x_35px.webp 2560w   
                                    "
                                        src="https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_2560_x_35px.webp" 
                                        alt="downlight accessories combo offer scroll banner"
                                />
                            </a>
                        </div>
                        {/* <div className="text-banner">
                            <hr/>
                            <hr id="hr-4"/>
                            <div>
                                <hr id="hr-2"/>
                                <hr id="hr-5"/>
                                <div>
                                    <hr id="hr-3"/>
                                    <hr id="hr-6"/>
                                    THIS IS OUR <span className='new-site-text-colour'>NEW SITE</span>. PREFER OUR PREVIOUS LAYOUT? VISIT THE LEGACY SITE&nbsp; 
                                    <a 
                                        href='https://legacy.eelighting.ca/'
                                        target='_blank' 
                                        rel="noopener noreferrer"
                                        onClick={()=> Event("Scroll banner text", `Legacy Website link from Scroll banner text clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text Legacy Website")}
                                    >
                                        HERE
                                    </a> 
                                    .                                   
                                </div> 
                            </div>
                        </div>   */}
                        {isBetweenDecemberAndJanuary &&
                        <div className="square">                                    
                            <a 
                                href='https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/holiday-hours/EELighting_December_Hours_-_Letter_Sized_Notice.pdf'
                                target='_blank' 
                                rel="noopener noreferrer"
                                onClick={()=> Event("Scroll banner text", `Holiday hours clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text Holiday hours")}
                            >
                                <img
                                    className="holiday-hours"
                                    srcSet="
                                        https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/EELighting_December_Hours_-_Scrolling_Text_Banner_1024px_x_35px_-_Position_1.webp 1024w,
                                        https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/EELighting_December_Hours_-_Scrolling_Text_Banner_1440px_x_35px_-_Position_1.webp 1440w,
                                        https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/EELighting_December_Hours_-_Scrolling_Text_Banner_2560px_x_35px_-_Position_1.webp 2560w"
                                        src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/EELighting_December_Hours_-_Scrolling_Text_Banner_2560px_x_35px_-_Position_1.webp" 
                                        alt="holiday scroll banner"
                                />
                            </a>
                        </div>
                        }
                        {/* <div className="text-banner">
                            <hr/>
                            <hr id="hr-4"/>
                            <div>
                                <hr id="hr-2"/>
                                <hr id="hr-5"/>
                                <div>
                                    <hr id="hr-3"/>
                                    <hr id="hr-6"/>
                                    PARDON US AS WE CONTINUE TO MAKE IMPROVEMENTS TO OUR <span className='new-site-text-colour'>NEW SITE</span>. LEAVE FEEDBACK&nbsp; 
                                    <Link 
                                        to='/website-feedback'
                                        onClick={()=> Event("Scroll banner text", `Website Feedback link from Scroll banner text clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text website feedback")}
                                    >
                                        HERE
                                    </Link> 
                                    .                                   
                                </div> 
                            </div>
                        </div> */}                     
                    </TextLoop>
                </div>
                <div className="small-screen">
                    <div id="container">                        
                        <div className="photobanner">                                                     
                            {window.location.hostname === "eel-client-internal-dev.herokuapp.com" &&
                            <img 
                                id="dev"
                                srcSet="
                                    https://eelighting-res.cloudinary.com/image/upload/c_pad,h_36,w_426/eelighting/promo-banners/scrolling-text-banner/EELighting-Dev-Site-Banner.webp 425w,
                                    https://eelighting-res.cloudinary.com/image/upload/c_pad,h_36,w_769/eelighting/promo-banners/scrolling-text-banner/EELighting-Dev-Site-Banner.webp 768w
                                "
                                src="https://eelighting-res.cloudinary.com/image/upload/c_pad,h_36,w_769/eelighting/promo-banners/scrolling-text-banner/EELighting-Dev-Site-Banner.webp"
                                alt='dev site'
                            />  
                            }                                                  
                            <Link 
                                to='/lp/mto'
                                onClick={()=> Event("Scroll banner text", `BusinessUpdate clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text Business Update")}
                            >                    
                                <img 
                                    id="mto"
                                    srcSet="
                                        https://eelighting-res.cloudinary.com/image/upload/c_pad,h_36,w_426/eelighting/promo-banners/scrolling-text-banner/ICON_-EEL-MTO-Services-_for-dark-BGs.webp 425w,
                                        https://eelighting-res.cloudinary.com/image/upload/c_pad,h_36,w_769/eelighting/promo-banners/scrolling-text-banner/ICON_-EEL-MTO-Services-_for-dark-BGs.webp 768w
                                    "
                                    src="https://eelighting-res.cloudinary.com/image/upload/c_pad,h_36,w_769/eelighting/promo-banners/scrolling-text-banner/ICON_-EEL-MTO-Services-_for-dark-BGs.webp"
                                    alt='mto services'
                                />                          
                            </Link>                    
                            <a 
                                aria-label="Downlight accessories combo offer link" 
                                href='/promo/downlight-accessories-combo-offer'
                                target='_blank' 
                                rel="noopener noreferrer"
                                onClick={()=> Event("Mobile scroll banner text", `Downlightaccessoriescombo clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Mobile scroll banner text downlight accessories combo offer link")}
                            >
                                <img
                                    srcSet="
                                    https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_425px_x_35px.webp 425w ,
                                    https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_768px_x_35px.webp 768w                                     
                                    "
                                        src="https://eelighting-res.cloudinary.com/image/upload/eelighting/promo-banners/downlight-accessories-combo-offer/scrolling-text-banner/EELighting_Downlight_Accessories_Combo_Offers_-_Scrollling_Text_Banner_768px_x_35px.webp" 
                                        alt="downlight accessories combo offer scroll banner"
                                />
                            </a>
                            {/* <a 
                                href='https://legacy.eelighting.ca/'
                                target='_blank' 
                                rel="noopener noreferrer"
                                onClick={()=> Event("Mobile scroll banner text", `Legacy Website link from Mobile scroll banner text clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Mobile scroll banner text Legacy Website")}
                            >
                                <img 
                                    src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/image.webp" 
                                    alt="Legacy Website"
                                />
                            </a> */}
                            {isBetweenDecemberAndJanuary &&
                            <a 
                                href='https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/holiday-hours/EELighting_December_Hours_-_Letter_Sized_Notice.pdf'
                                target='_blank' 
                                rel="noopener noreferrer"
                                onClick={()=> Event("Scroll banner text", `Holiday hours clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Scroll banner text Holiday hours")}
                            > 
                                <img 
                                    className="holiday-hours"
                                    src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/EELighting_December_Hours_-_Scrolling_Text_Banner_1024px_x_35px_-_Position_1.webp" 
                                    alt="holiday hours"
                                />                            
                            </a>
                            }
                            {/* <Link 
                                to='/website-feedback'
                                onClick={()=> Event("Mobile scroll banner text", `Website Feedback link from Mobile scroll banner text clicked by ${Cookies.get('user_id') || "not logged in user"}`, "Mobile scroll banner text website feedback")}
                            >
                                <img 
                                    src="https://eelighting-res.cloudinary.com/image/upload/eelighting/creative-assets/eel-assets/scrolling_banners/image_1.webp" 
                                    alt="website feedback"
                                />
                            </Link>                             */}                                                                              
                        </div>
                    </div>
                </div>
            </div>            
        )
    }
}